import React from 'react';
import {
    TableCell,
    TableHead,
    TableRow
} from 'material-ui/Table';

const TagTranslationsTableHeader = ({classes}) => (
    <TableHead>
        <TableRow className={classes.headerTags}>
            <TableCell width={140} className={classes.tableCell}>Translation ID</TableCell>
            <TableCell width={120} className={classes.tableCell}>Website ID</TableCell>
            <TableCell width={180} className={classes.tableCell}>Website Name</TableCell>
            <TableCell width={370} className={classes.tableCell}>* Tag Translated Name</TableCell>
            <TableCell width={120} className={classes.tableCell}>Actions</TableCell>
        </TableRow>
    </TableHead>
)

export default TagTranslationsTableHeader;


// WEBPACK FOOTER //
// ./src/containers/tags/translations/TagTranslationsTableHeader.jsx